import React, {useState} from "react";
import * as palette from "../Variables";

const Resume = () => {

    return (
        <main>
            <section>
                <p>Resume page</p>
            </section>
        </main>
    )
}

export default Resume;